import type { StepType } from 'components/layout';
import ChooseCreatives from './ChooseCreatives';
import ChooseAccount from './ChooseAccount';
import ChooseCampaigns from './ChooseCampaigns';
import ChooseAdGroups from './ChooseAdGroups';
import AdTextsStep from './AdTextsStep';

export const PINTEREST_STEPS: StepType[] = [
  { title: 'Creatives', component: ChooseCreatives },
  { title: 'Ad Account', component: ChooseAccount },
  { title: 'Campaigns', component: ChooseCampaigns },
  { title: 'Ad groups', component: ChooseAdGroups },
  { title: 'Ad', component: AdTextsStep },
];
